import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import GeneralNotificationContext from "../../../context/general-notification/context";
import { IGeneralNotification } from "../../../models/general-notification/response";
import Space from "../../general/antd/space";
import ViewBtn from "../../general/table-components/actions/view-btn";
import EditBtn from "../../general/table-components/actions/edit-btn";
import DeleteBtn from "../../general/table-components/actions/delete-btn";
import eventManager, { EVENT_SUCCESS } from "../../../utils/events";
import { ISort, IStaticFilter } from "../../../models/base/base-query";
import { tableOnChange } from "../../../utils/helpers/table-sorts-filters";
import Table from "../../general/table-components/table";
import { Button } from "antd";
import { FileExcelOutlined, SendOutlined } from "@ant-design/icons";
import { getNotificationType } from "../../../models/general-notification/enum";

interface IProps {}

const GeneralNotificationTable: React.FC<IProps> = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { list, actions, loading, query } = useContext(
    GeneralNotificationContext
  );

  const columns: ColumnProps<IGeneralNotification>[] = [
    {
      title: t("id"),
      dataIndex: "id",
      key: "id",
      sorter: {
        multiple: 1,
      },
      width: 100,
      align: "center",
    },
    {
      title: t("title"),
      dataIndex: "title",
      align: "center",
      key: "name",
    },
    {
      title: t("text"),
      dataIndex: "body",
      align: "center",
      key: "body",
      render: (_: any, record) => (
        <>
          <div>
            {
              //@ts-ignore
              record?.body
            }
          </div>
        </>
      ),
    },
      {
          title: t("user_slide"),
          dataIndex: "topic",
          align: "center",
          key: "topic",
          render: (_: any, record) => (
              <>
                  <div>
                      {
                          //@ts-ignore
                          t(record?.topic)
                      }
                  </div>
              </>
          ),
      },
    {
      title: t("type"),
      dataIndex: "type",
      align: "center",
      key: "type",
      render: (_: any, record) => (
        <>
          <div>
            {
              //@ts-ignore
              t(getNotificationType(record?.type))
            }
          </div>
        </>
      ),
    },
    {
      title: t("actions"),
      width: 250,
      dataIndex: "",
      align: "center",
      key: "x",
      render: (_: any, record) => (
        <Space>
          <ViewBtn
            onClick={async () => {
              navigate(`details/${record?.id}`);
            }}
          />
          <EditBtn
            onClick={async () => {
              navigate(`update/${record?.id}`);
            }}
          />
          <Button
            type="dashed"
            shape="circle"
            loading={loading.includes("notifi")}
            onClick={() => {
              actions.sendNotification(record?.id);
            }}
            icon={<SendOutlined />}
          />

          <DeleteBtn
            onConfirm={async () => {
              await actions.deleteGeneralNotification(record?.id);
              eventManager.emit(EVENT_SUCCESS);
            }}
            loading={loading.includes("delete")}
          />
        </Space>
      ),
    },
  ];

  // Filters && Sorts
  let tableFiltersProps = {};
  const [sorts, setSorts] = useState<ISort[]>([]);
  const [, setStaticFilters] = useState<IStaticFilter[]>(query?.filters ?? []);

  useEffect(() => {
    sorts.length > 0 &&
      actions.setQuery({
        ...query,
        orders: sorts,
      });
  }, [sorts]);

  return (
    <>
      <Table<any>
        rowKey="id"
        showPagination={true}
        columns={columns}
        dataSource={list?.data ?? []}
        loading={loading.includes("list")}
        size="small"
        total={list?.total}
        pageSize={query.perPage}
        page={query.page}
        onPaginationChange={(page, pageSize) => {
          actions.setQuery({
            ...query,
            page,
            perPage: pageSize,
          });
        }}
        onChange={(_, tableFilters, tabelSorters) => {
          tableOnChange(
            tableFilters,
            tabelSorters,
            tableFiltersProps,
            setSorts,
            setStaticFilters
          );
        }}
      />
    </>
  );
};

export default GeneralNotificationTable;
